import { CloseSmall } from '@icon-park/react';
import { memo } from 'react';
import { components, type GroupBase, type MultiValueRemoveProps } from 'react-select';

export const MultiValueRemoveBase = <
  TOption,
  IsMulti extends boolean,
  TGroup extends GroupBase<TOption>,
>(
  props: MultiValueRemoveProps<TOption, IsMulti, TGroup>,
) =>
  props.selectProps.isDisabled ? null : (
    <components.MultiValueRemove {...props}>
      <CloseSmall />
    </components.MultiValueRemove>
  );

MultiValueRemoveBase.displayName = 'MultiValueRemove';

export default memo(MultiValueRemoveBase);
